import { get } from 'lodash';

// local dependencies
import { HttpService } from 'core/modules/network-service';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';

/*************************************************************/

/**
 * @type {class}
 * @desc PriorAuthorization defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { PriorAuthorizationService } from 'services/priorAuthorization';
 *
 * // create service instance and send/cancel request
 * const priorAuthorizationService = new PriorAuthorizationService();
 * const result = await priorAuthorizationService.fetchData( '<user-id>' ); // fetch data
 * priorAuthorizationService.cancel(); // cancel an active request
 */
export class PriorAuthorizationService extends HttpService {

    // submit form data
	CONFIG;
    async submitFormData( { url, data } ) {
        try {
            const response = await this.post( {
                host: this.CONFIG.host,
                path: url,
                data: data
            } );

            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE )
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE
            };
        }
    }

    // format error response
    _errorFormatter( errResponse ) {
        return errResponse; // some logic
    }
}
